<template>
  <rb-modal :options="modalOptions" @cancel="cancel()" @hide="confirmed && hide()">
    <span slot="header">{{ headerText }}</span>
    <div slot="body">
      <p>{{ messageText }}</p>

      <p v-if="confirmationText">
        <rb-checkbox-button :value="confirmed" check-box-value="1" @input="setConfirmed" />
        {{ confirmationText }}
      </p>
    </div>
  </rb-modal>
</template>

<script>
  import DialogMixin from 'vRoot/_mixins/DialogMixin.vue'
  import RbEventsMixin from 'vRoot/_mixins/RbEventsMixin.vue'
  import RbModal from 'vRoot/_core/RbModal.vue'
  import RbCheckboxButton from 'vRoot/_core/RbCheckboxButton.vue'

  export default {
    name: 'RbvHotelRfpBidManagerQuestionMixin',
    components: { RbModal, RbCheckboxButton },
    mixins: [ DialogMixin, RbEventsMixin ],
    data () {
      return {
        confirmed: false,
        modalOptions: { labels: { buttons: { apply: 'Confirm' } } }
      }
    },
    methods: {
      setConfirmed(event) { this.confirmed = event }
    }
  }
</script>
